import validationErrorHandler from './validation-error';
var errorHandlerMap = new Map([['ValidationError', validationErrorHandler]]);
var graphQLErrorHandler = function graphQLErrorHandler(err) {
  var errorHandler = errorHandlerMap.get(err.extensions.classification);
  if (typeof errorHandler === 'function') {
    return errorHandler(err);
  }
  return null;
};
export default graphQLErrorHandler;